import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME, MetricsConsentAutoCorrectionState} from './metricsConsentAutoCorrection';

export const selectMetricsConsentAutoCorrectionState: MemoizedSelector<object, MetricsConsentAutoCorrectionState> = createFeatureSelector<MetricsConsentAutoCorrectionState>(METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME);

export const selectMetricsConsentAutoCorrectionLoading: MemoizedSelector<object, boolean> = createSelector(
  selectMetricsConsentAutoCorrectionState,
  (state: MetricsConsentAutoCorrectionState): boolean => state.loading
);

export const selectMetricsConsentAutoCorrectionProcessing: MemoizedSelector<object, boolean> = createSelector(
  selectMetricsConsentAutoCorrectionState,
  (state: MetricsConsentAutoCorrectionState): boolean => state.processing
);

export const selectMetricsConsentAutoCorrectionIsEnabled: MemoizedSelector<object, boolean> = createSelector(
  selectMetricsConsentAutoCorrectionState,
  (state: MetricsConsentAutoCorrectionState): boolean => state.enabled
);

export const selectMetricsConsentAutoCorrectionStatus: MemoizedSelector<object, 'not-configured' | 'off' | 'on'> = createSelector(
  selectMetricsConsentAutoCorrectionState,
  (state: MetricsConsentAutoCorrectionState): 'not-configured' | 'off' | 'on' => state.status
);

export const selectMetricsConsentAutoCorrectionButtonIcon: MemoizedSelector<object, 'auto_fix_normal' | 'auto_fix_off'> = createSelector(
  selectMetricsConsentAutoCorrectionState,
  (state: MetricsConsentAutoCorrectionState): 'auto_fix_normal' | 'auto_fix_off' => state.buttonIcon
);

